import { Component, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService, UtilSchoolProjectVM } from '../../services/api';
import { NgxChartsModule, ScaleType } from '@swimlane/ngx-charts';
import { DatePipe } from '@angular/common';
import { scaleBand } from 'd3-scale';
import {MatSort, Sort} from '@angular/material/sort';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import { Router } from '@angular/router';

@Component({
	selector: 'util-grid-report',
	templateUrl: 'util-grid-report.component.html',
	styleUrls: ['util-grid-report.component.scss'],
	providers: [DatePipe]

})

export class UtilGridReportComponent implements OnInit, OnChanges {
	@Input() schoolId:number = -1;
	@Input() projectId:number | undefined = -1;
	@Input() isout:boolean | undefined = false;
	@Input() viewsize: [number, number] = [1100, 200];
  	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();


	displayedColumns: string[] = ['chart','schoolName','lastSync','activeDevices', 'totalDevies', 'schoolType', 'level1', 'level2', 'level3'];;
	reportdata :any[] = [];
  nodata = true;
	dataSource = new MatTableDataSource<UtilSchoolProjectVM>(this.reportdata);
	@ViewChild(MatPaginator) paginator: MatPaginator|null = null;
	// options
	view : [number, number] = [100,50];
	legend: boolean = true;
	showLabels: boolean = true;
	animations: boolean = true;
	xAxis: boolean = true;
	yAxis: boolean = true;
	showYAxisLabel: boolean = true;
	showXAxisLabel: boolean = true;
	colorScheme = [{"name": "utilization","value": "#4F94D3"}];
	timeline: boolean = true;
	currentDate : string = '';
	startDate: Date = new Date();
	endDate: Date = new Date();


	ngOnInit() {


	}


  ngOnChanges(changes: SimpleChanges): void {
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);
			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout){
				this.startDate = new Date(today.getTime() - (365 * day));
      		}
			else{
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate;
			}


      if(this.schoolId != -1){
        //this.getSchoolReports()
      }else{
        this.getProjectReports();
      }

	}

	}


	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	onSelectDate(){
    this.reportdata = [];
    this.nodata = true;
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else{
			this.getProjectReports();
		}
	}


	private getSchoolReports(){
		this.service.analyticsGetTitleSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			//this.prepareData(data)
		});
	}

	private getProjectReports(){
		this.service.analyticsGetUtilSchoolProjectReportPost(this.projectId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{

			this.prepareData(data);
			console.log(this.reportdata);
			this.dataSource = new MatTableDataSource<UtilSchoolProjectVM>(this.reportdata);
			this.dataSource.paginator = this.paginator;
		});
	}


	private prepareData(data:any[]){
		console.log(data);
    if(this.isout && !data.some(itm => itm["chartData"].length > 0)) return;
    this.nodata = false;
		let currentdata:any[] = [];
		data.forEach(item =>{
			currentdata.push(this.getGridData(item));

		});

		this.reportdata = currentdata;
	}

	private getGridData(item:any){
		return {
			schoolId: item.schoolId,
			schoolName : item.schoolName,
			activeDevices: item.activeDevices,
			totalDevices : item.totalDevices,
			latestSyncUpdate : item.latestSyncUpdate,
			schoolType : item.schoolType,
			level2 : item.level2,
			level1 : item.level1,
			level3 : item.level3,
			chart : this.prepareChartData(item.chartData)
		}
	}

	public prepareChartData(data : any[]){
		let currentdata:any[] = [];
		data.forEach(item =>{
			let daydata = this.getData(item.eventTime, item.activeDevices,item.totalDevices);
			currentdata.push(daydata);

		});

		return  [{
			name: 'utilization',
			series: currentdata
		}];


	}

	navigateBack(){
		this.backEvent.next(null);
	}

	constructor(private service: AnalyticsService,
		private datePipe: DatePipe,
		private router: Router) {
		const today = new Date()
		let day = 86400000
		this.startDate = new Date(today.getTime() - (3 * 30 * day));
	}


	getData(day: string, sync: number, total:number){
		console.log('sync' + sync);
		let util = (sync*1.0)/(total*1.0);
		util = Math.round(util * 100);
		return  {name:day.split('T')[0],value:util,toolTipText:''};
	}

	public schoolsSortChange(sort:Sort){
		const data = this.reportdata.slice();
		if (!sort.active || sort.direction === '') {
		this.reportdata = data;
		return;
		}

		this.reportdata = data.sort((a, b) => {
		const isAsc = sort.direction === 'asc';
		switch (sort.active) {
			case 'schoolName': return this.compare(a['schoolName'], b['schoolName'], isAsc);
			case 'lastSync': return this.compare(a['activeDevices'], b['activeDevices'], isAsc);
			case 'activeDevices': return this.compare(a['activeDevices'], b['activeDevices'], isAsc);
			case 'totalDevies': return this.compare(a['totalDevies'], b['totalDevies'], isAsc);
			case 'schoolType': return this.compare(a['schoolType'], b['schoolType'], isAsc);
			case 'level1': return this.compare(a['level1'], b['level1'], isAsc);
			case 'level2': return this.compare(a['level2'], b['level2'], isAsc);
			case 'level3': return this.compare(a['level3'], b['level3'], isAsc);
			default: return 0;
		}
		});
		this.dataSource = new MatTableDataSource<UtilSchoolProjectVM>(this.reportdata);
		this.dataSource.paginator = this.paginator;
	}



compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}


navigateTo(entity:UtilSchoolProjectVM){
    this.router.navigate(["/admin/schools",entity.schoolId])
  }


}
